import React from 'react';
import { Briefcase, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { portfolioData } from '../mock';

const Experience = () => {
  const { experience } = portfolioData;

  return (
    <section id="experience" className="py-16 sm:py-24 bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
              Work Experience
            </h2>
            <p className="text-gray-400 text-base sm:text-lg">My professional journey</p>
          </div>

          {/* Timeline */}
          <div className="relative">
            {/* Vertical line */}
            <div className="hidden sm:block absolute left-0 sm:left-8 top-0 bottom-0 w-0.5 bg-cyan-400/30"></div>

            {/* Experience Cards */}
            <div className="space-y-8 sm:space-y-12">
              {experience.map((exp, index) => (
                <div key={exp.id} className="relative">
                  {/* Timeline dot */}
                  <div className="hidden sm:flex absolute left-0 sm:left-8 w-4 h-4 bg-cyan-400 rounded-full transform -translate-x-1/2 ring-4 ring-slate-900"></div>

                  {/* Content */}
                  <div className="sm:ml-16">
                    <Card className="bg-slate-800/50 border-slate-700 hover:border-cyan-400/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-400/10">
                      <CardContent className="p-6 sm:p-8">
                        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between mb-4 gap-2">
                          <div>
                            <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">
                              {exp.role}
                            </h3>
                            <div className="flex items-center text-cyan-400 gap-2 mb-2">
                              <Briefcase size={18} />
                              <span className="font-semibold text-base sm:text-lg">{exp.company}</span>
                            </div>
                          </div>
                          <span className="text-gray-400 text-sm sm:text-base whitespace-nowrap bg-slate-700/50 px-3 py-1 rounded-full self-start">
                            {exp.duration}
                          </span>
                        </div>

                        <ul className="space-y-3 text-gray-300">
                          {exp.responsibilities.map((resp, idx) => (
                            <li key={idx} className="flex gap-3 text-sm sm:text-base">
                              <span className="text-cyan-400 mt-1.5 flex-shrink-0">▹</span>
                              <span>{resp}</span>
                            </li>
                          ))}
                        </ul>

                        {exp.achievement && (
                          <div className="mt-4 flex items-start gap-2 bg-cyan-400/10 border border-cyan-400/30 rounded-lg p-3">
                            <Award size={20} className="text-cyan-400 flex-shrink-0 mt-0.5" />
                            <p className="text-cyan-400 font-semibold text-sm sm:text-base">{exp.achievement}</p>
                          </div>
                        )}
                      </CardContent>
                    </Card>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;